import React, { useState, useEffect } from 'react';
import moment from 'moment';

const ApplyPaymentModal = ({
  isShow, rentalData, onChangeFunc, saveFunc, toggleFunc
}) => {
  const [paymentData, setPaymentData] = useState({
    paymentMethod: '',
    paymentBankName: '',
    paymentAccountNumber: '',
    paymentAccountHolderName: '',
    paymentReceiptAmount: '',
    paymentMethodOther: '',
    paymentTotalAmount: '',
    paymentRemarks: ''
  });

  // 当表单打开时，初始化数据
  useEffect(() => {
    if (isShow && rentalData) {
      const predefinedMethods = ['匯款', '支票', '現金'];
      let paymentMethod = rentalData.paymentMethod || '';
      let paymentMethodOther = '';

      // 检查paymentMethod是否在预定义列表中
      if (paymentMethod && !predefinedMethods.includes(paymentMethod)) {
        // 不在预定义列表中，设为「其他」
        paymentMethodOther = paymentMethod;
        paymentMethod = '其他';
      }

      // 計算 paymentRemarks
      let remarksValue = rentalData.paymentRemarks || '';
      if (!remarksValue) {
        const codeStr = rentalData.paymentCode ? `後五碼${rentalData.paymentCode}` : '後五碼未填';
        const remarkStr = rentalData.remarks || '';
        remarksValue = remarkStr ? `${codeStr}，${remarkStr}` : codeStr;
      }

      setPaymentData({
        paymentMethod: paymentMethod,
        paymentBankName: rentalData.paymentBankName || '',
        paymentAccountNumber: rentalData.paymentAccountNumber || '',
        paymentAccountHolderName: rentalData.paymentAccountHolderName || '',
        paymentReceiptAmount: rentalData.paymentReceiptAmount || '',
        paymentMethodOther: paymentMethodOther || rentalData.paymentMethodOther || '',
        paymentTotalAmount: rentalData.prepaymentAmount  || '',
        paymentRemarks: remarksValue
      });
    }
  }, [isShow, rentalData]);

  const handlePaymentDataChange = (field, value) => {
    setPaymentData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    
    // 验证付款方式为必填
    if (!paymentData.paymentMethod) {
      alert('付款方式為必填！');
      return;
    }

    // 如果选择其他，检查其他付款方式文字
    if (paymentData.paymentMethod === '其他' && !paymentData.paymentMethodOther) {
      alert('請輸入其他付款方式！');
      return;
    }
    
    if (!paymentData.paymentBankName) {
      alert('銀行名稱為必填！');
      return;
    }
    
    if (!paymentData.paymentAccountNumber) {
      alert('帳號為必填！');
      return;
    }
    
    if (!paymentData.paymentAccountHolderName) {
      alert('帳戶名為必填！');
      return;
    }
    
    if (!paymentData.paymentReceiptAmount) {
      alert('收據金額為必填！');
      return;
    }

    // 如果选择其他，将用户输入的值作为paymentMethod
    const finalData = { ...paymentData };
    if (paymentData.paymentMethod === '其他') {
      finalData.paymentMethod = paymentData.paymentMethodOther;
    }

    saveFunc(finalData);
  };

  if (!rentalData) return null;

  const prepaymentAmount = Number(rentalData.prepaymentAmount || 0);
  const rentalAmount = Number(rentalData.rentalAmount || 0);
  const serviceFee = Number(rentalData.serviceFee || 0);
  const mealFee = Number(rentalData.mealFee || 0);
  const totalAmount = Number(rentalData.paymentTotalAmount || paymentData.paymentTotalAmount || rentalData.prepaymentAmount || 0);
  const remark = rentalData.paymentRemarks || paymentData.paymentRemarks || rentalData.remarks || '';

  return (
    <div className="u-editblock fadeIn" style={{ display: isShow ? 'flex' : 'none', overflow: 'auto', justifyContent: 'center' }}>
      <div className="form-block u-rentall" style={{ minWidth: '700px', border: '1px solid black', padding: '0' }}>
        <div className="u-small-title" style={{ padding: '16px', border: '1px solid black' }}>
          申請請款單
        </div>
        <form className="u-form" style={{ margin: '0' }}>
          {/* 申請日期 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold', textAlign: 'center' }}>申請日期</div>
            <div style={{ flex: 1, padding: '8px' }}>
              {moment().format('YYYY-MM-DD')}
            </div>
          </div>

          {/* 付款對象 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' , textAlign: 'center'}}>付款對象</div>
            <div style={{ flex: 1, padding: '8px' }}>
              {rentalData.tenantName || ''}
            </div>
          </div>

          {/* 付款明細 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' , textAlign: 'center'}}>付款明細</div>
            <div style={{ flex: 1, padding: '8px' }}>
              <div style={{ marginBottom: '8px' }}>
                {prepaymentAmount > 0 && (
                  <span style={{ marginRight: '20px' }}>預收金額: <strong>{prepaymentAmount}</strong></span>
                )}
              </div>
            </div>
          </div>

          {/* 金額 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' , textAlign: 'center'}}>金額</div>
            <div style={{ flex: 1, padding: '8px', display: 'flex', alignItems: 'center', gap: '8px'}}>
              <span>總金額$</span>
              <input
                type="number"
                value={paymentData.paymentTotalAmount || 0}
                onChange={e => handlePaymentDataChange('paymentTotalAmount', e.target.value)}
                className="u-form__input underline"
                style={{ border: '1px solid rgb(204, 204, 204)', padding: '4px', flex: '1', textAlign: 'right' }}
              />
              <span>元</span>
            </div>
          </div>

          {/* 付款資訊區塊 - 包含付款方式、銀行名稱、帳號、帳戶名、收據金額 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            {/* rowspan 標籤 */}
            <div style={{ 
              width: '150px', 
              padding: '8px', 
              borderRight: '1px solid black', 
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              付款方式
            </div>

            {/* 付款資訊內容 */}
            <div style={{ flex: 1 }}>
              {/* 付款方式 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <select
                  value={paymentData.paymentMethod || ''}
                  onChange={e => handlePaymentDataChange('paymentMethod', e.target.value)}
                  className="u-form__input underline"
                  style={{ height: '36px', minHeight: '36px', fontSize: '16px', lineHeight: '1.5', padding: '6px 12px', width: '100%', border: '1px solid #ccc' }}
                >
                  <option value="">請選擇付款方式</option>
                  <option value="匯款">匯款</option>
                  <option value="支票">支票</option>
                  <option value="現金">現金</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              {/* 其他付款方式 - 當選擇其他時顯示 */}
              {paymentData.paymentMethod === '其他' && (
                <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                  <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>其他方式</label>
                  <input
                    type="text"
                    placeholder="請輸入其他付款方式"
                    value={paymentData.paymentMethodOther || ''}
                    onChange={e => handlePaymentDataChange('paymentMethodOther', e.target.value)}
                    className="u-form__input underline"
                    style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
                  />
                </div>
              )}

              {/* 銀行名稱 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>銀行名稱</label>
                <input
                  type="text"
                  value={paymentData.paymentBankName || ''}
                  onChange={e => handlePaymentDataChange('paymentBankName', e.target.value)}
                  className="u-form__input underline"
                  style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
                />
              </div>

              {/* 帳號 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>帳號</label>
                <input
                  type="text"
                  value={paymentData.paymentAccountNumber || ''}
                  onChange={e => handlePaymentDataChange('paymentAccountNumber', e.target.value)}
                  className="u-form__input underline"
                  style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
                />
              </div>

              {/* 帳戶名 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>帳戶名</label>
                <input
                  type="text"
                  value={paymentData.paymentAccountHolderName || ''}
                  onChange={e => handlePaymentDataChange('paymentAccountHolderName', e.target.value)}
                  className="u-form__input underline"
                  style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
                />
              </div>

              {/* 收據金額 */}
              <div style={{ padding: '8px' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>金額</label>
                <input
                  type="number"
                  value={paymentData.paymentReceiptAmount || ''}
                  onChange={e => handlePaymentDataChange('paymentReceiptAmount', e.target.value)}
                  className="u-form__input underline"
                  style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px', textAlign: 'right' }}
                />
              </div>
            </div>
            
          </div>
                                  {/* 備註事項 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold', textAlign: 'center' }}>備註事項</div>
            <div style={{ flex: 1, padding: '8px' }}>
                <input
                  type="text"
                  value={paymentData.paymentRemarks || ''}
                  onChange={e => handlePaymentDataChange('paymentRemarks', e.target.value)}
                  className="u-form__input underline"
                  style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
                />
            </div>
          </div>
          {/* 按鈕組 */}
          <div className="u-btn-group right" style={{ padding: '16px', textAlign: 'right' }}>
            <button className="btn btn-md save" onClick={handleSave} style={{ marginRight: '16px' }}>
              儲存
            </button>
            <button className="btn btn-md cancel" onClick={e => { e.preventDefault(); toggleFunc(); }}>
              取消
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ApplyPaymentModal;
